// RESET Library: 3D body model.
// Progressive enhancement: the original SVG body stays visible until <model-viewer>
// has loaded the GLB. If the model file, the CDN script, or WebGL is unavailable,
// the SVG body (and its hotspots) keeps working exactly as before.
//
// The theme code editor corrupts binary uploads (it treats them as UTF-8 text), so the
// model ships as plain text: assets/reset-supply-model.json = { "glb": "<base64>" }.
// It is decoded here into a Blob URL and handed to <model-viewer>.
const MODEL_JSON = new URL("reset-supply-model.json", import.meta.url);
let modelUrl;

const loadModelUrl = async () => {
  if (modelUrl) return modelUrl;
  const response = await fetch(MODEL_JSON, { credentials: "same-origin" });
  if (!response.ok) throw new Error("Model file unavailable");
  const { glb } = await response.json();
  if (typeof glb !== "string" || !glb) throw new Error("Invalid model file");
  const binary = atob(glb);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  modelUrl = URL.createObjectURL(new Blob([bytes], { type: "model/gltf-binary" }));
  return modelUrl;
};

const bind = (body) => {
  if (body.dataset.modelBound) return;
  const viewer = body.querySelector("model-viewer");
  if (!viewer) return;
  body.dataset.modelBound = "true";
  const ready = () => {
    body.dataset.model = "ready";
  };
  const failed = () => {
    body.dataset.model = "error";
  };
  viewer.addEventListener("load", ready);
  viewer.addEventListener("error", failed);
  // Attribute (not property) so this is safe before model-viewer has upgraded the element.
  loadModelUrl()
    .then((url) => viewer.setAttribute("src", url))
    .catch(failed);
};

const bindAll = () => document.querySelectorAll(".reset-peptide-body[data-model]").forEach(bind);

bindAll();
// Theme editor re-renders sections without a page load.
document.addEventListener("shopify:section:load", bindAll);
